<template>
    <!-- 场地管理－修修改场次时间 -->
    <content-view>
        <div class="amendScreening">
            <a-alert
                style="margin-bottom:20px"
                description="库存设置成功立即生效，请慎重操作！"
                type="warning"
                showIcon
            />
            <div id="components-layout-demo-basic">
                <a-layout>
                    <a-layout-sider style="border:1px solid rgba(233, 233, 233, 1)">
                        <inventory-list></inventory-list>
                    </a-layout-sider>
                    <a-layout style="background:#fff">
                        <a-form :form="form" @submit="onSubmit">
							<div class="district">
								<table style="line-height:34px;" class="mb16">
									<tr>
										<td width="80" class="text-right pr8">
											日期范围:
										</td>
										<td>
											<a-form-item style="margin:0;">
												<a-range-picker v-decorator="['dateRange', {rules:[{required: true, message: '请输入'}]}]" style="width:100%;"/>
											</a-form-item>
										</td>
										<td width="80" class="text-right pr8">
											时间范围:
										</td>
										<td>
											<a-form-item style="margin:0;">
												<a-time-picker v-decorator="['time0']" format="HH:mm" style="width:45%"/>
												至
												<a-time-picker v-decorator="['time1']" format="HH:mm" style="width:45%"/>
											</a-form-item>
										</td>
									</tr>
								</table>
								<table style="line-height:34px;" class="mb16">
									<tr>
										<td width="80" class="text-right pr8">
											选择星期:
										</td>
										<td>
											<a-form-item style="margin:0;">
												<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
												<a-checkbox-group :options="weekOption" @change="onWeekChange" v-model="weedSelected"></a-checkbox-group>
											</a-form-item>
										</td>
									</tr>
								</table>
								<a-form-item class="text-right">
									<div class="mr24">
										<a-button type="primary" html-type="submit">筛选</a-button>
										<a-button @click="resetForm">重置</a-button>
									</div>
								</a-form-item>
								<a-alert
									class="a-alert"
									description="请选择要修改的场次，场次可用日期确认无误再修改"
									type="warning"
									showIcon
								/>
								<div class="tableBox">
									<a-table
										:columns="columns"
										:dataSource="data"
										:rowKey="(record,index) => index"
										:pagination="false"
										:scroll="{y:scrollHeight}"
										:loading="tableShowLoading"
										bordered
									>
									<template slot="dateList" slot-scope="text,record,index">
										有
										{{record.dateList[0]}}
										等
										{{record.dateList.length}}
										个日期可用
										<span class="point text-primary" @click="lookData(index)">查看</span>
									</template>
									<span slot="state" slot-scope="a,row">
										<a class="text-primary" @click="showModal(row)">编辑</a>
										<a-divider type="vertical"></a-divider>
										<a-popconfirm title="确认删除该场次吗？" @confirm="delPeriod(row)" okText="是" cancelText="否">
											<a class="text-primary">删除库存</a>
										</a-popconfirm>
									</span>
								</a-table>
								</div>
							</div>
						</a-form>
                    </a-layout>
                </a-layout>
            </div>
        </div>
		<!-- 修改场次库存弹窗 -->
        <a-modal
            title="修改场次库存"
            :visible="visible"
            @ok="handleOk"
            :confirmLoading="confirmLoading"
            @cancel="handleCancel"
        >
            <a-form :form="periodForm" class="store-one-form">
              	<a-form-item label="库存数量：" :label-col="{span: 6}" :wrapper-col="{span: 16}">
					<a-input placeholder="请输入" v-decorator="['stockNum',{rules:[{required:true,message:'请填写数量！'}]}]"></a-input>
			    </a-form-item>
            </a-form>
        </a-modal>

		<!-- 查看可用日期弹窗 -->
		<a-modal
            title="可用日期详情"
            :visible="visiblePeriod"
            @ok="visiblePeriod=false"
            @cancel="visiblePeriod=false"
        >
			<a-table 
				:columns="PeriodColumns"
				:dataSource="usefulPeriodData"
				:rowKey="(record,index) => index"
				:scroll="{y:scrollHeight}"
				:pagination="false"
				bordered>
				<template slot="periodDate" slot-scope="text,record, list">
					<div class="text-center">
						{{text}}
					</div>
				</template>
			</a-table>
        
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
import inventoryList from "@/components/modules/platform/Inventory.list.component";
import moment from "moment";
import { mapGetters } from "vuex";
/**
 *@weekOption 复选框组配置
 */
const weekOption=[
	{label:"周一",value:1},
	{label:"周二",value:2},
	{label:"周三",value:3},
	{label:"周四",value:4},
	{label:"周五",value:5},
	{label:"周六",value:6},
	{label:"周日",value:7},
	]
const columns = [
    {
        title: "场次名称",
		dataIndex: "reserveStockPeriodType",
		width:"15%"
    },
    {
        title: "场次开始时间",
		dataIndex: "startTime",
		width:"15%"		
    },
    {
        title: "场次结束时间",
		dataIndex: "endTime",
		width:"15%"		
    },
    {
        title: "每日库存总量",
		dataIndex: "capacity",
		width:"15%"		
    },
    {
        title: "可用日期",
		dataIndex: "dateList",
		scopedSlots: { customRender: 'dateList' },
		width:"30%"		
    },
    {
        title: "操作",
		dataIndex: "state",
		scopedSlots: { customRender: 'state' },
		width:"10%"		
    }
];
const PeriodColumns = [
    {
		title: "可用日期",
		scopedSlots: { customRender: 'periodDate' },
    },
];
export default {
    name: "amendScreening",
    components: { inventoryList },
    props: {},
    data() {
		/** 
		*@weekOption {array} 星期选择配置
		*@weedSelected {array} 星期选中项
		*@indeterminate {boolean} 半全选状态
		*@checkAll {boolean} 全选状态
		*@columns {array} 默认表头
		*@tableShowLoading {boolean} 表格加载状态
		*@data	{array} 默认表格数据
		*@visible {boolean} 修改库存弹窗状态
		*@confirmLoading {boolean} 修改库存弹窗保存按钮加载状态
		*@scrollHeight {number} 表格滚动区域的可见高度 
		*@visiblePeriod {boolean} 可用日期弹窗状态
		*@usefulPeriodData {array} 可用日期弹窗表格数据
		*@PeriodColumns {array} 可用日期弹窗表格表头
		*/
        return {
			weekOption,
			weedSelected:[],
			indeterminate:false,
			checkAll:false,
			columns,
			tableShowLoading:false,
            data:[],
            visible: false,
			confirmLoading: false,
			loading : false,
			scrollHeight:window.innerWidth/7,
			visiblePeriod:false,
			usefulPeriodData:[],
			PeriodColumns,
			selectedRowId: '',
			selectedRowId:null,
        };
    },
    computed: {
        ...mapGetters(["currentItem", "currnetId", "shopId"])
	},
	watch:{
		currnetId () {
			this.getPeriodList({id:this.currnetId});
		}
	},
    methods: {
        moment,
        showModal(row) {
			this.selectedRow = row;
			this.selectedRowId = row.id
			this.visible = true;
		},
		/**
		 * @handleOk {method} 修改库存数量
		 */
        handleOk() {
			this.periodForm.validateFields((err,values) =>{
				if(!err){
            		this.confirmLoading = true;
					this.$api.totalPlatform.setStoreNum({
						body:{
							"stockNum": values.stockNum,
							"reserveStockPeriodIds": this.selectedRow.reserveStockPeriodIds,
						}
					}).then(res =>{
						this.visible = false;
						this.confirmLoading = false;
						this.$message.success("修改成功！");
						this.getPeriodList();
					})
				}
			})
			
        },
        handleCancel(e) {
            this.visible = false;
        },
		/**
		 * @onSubmit {method} 筛选提交事件
		 */
		onSubmit (e){
			e.preventDefault();
			this.getPeriodList();
		},
		/**
		 *@onWeekChange {method} 是否全选状态判断
		 */
		onWeekChange (checkedList) {
			this.indeterminate = !!checkedList.length && (checkedList.length < weekOption.length)
			this.checkAll = checkedList.length === weekOption.length
		},
		/**
		 *@onCheckAllChange {method} 是否全选操作
		 */
		onCheckAllChange (e) {
			let weedVal=[];
			weekOption.forEach((item,index) =>{
				weedVal.push(item.value);
			})
			Object.assign(this, {
				weedSelected: e.target.checked ? weedVal : [],
				indeterminate: false,
				checkAll: e.target.checked,
			})
		},
		/**
		 * @getPeriodList {method} 库存配置场次列表
		 * @reqData {object} 请求数据{endDate，endTime，id(库存项目id)，startDate，startTime，weekdayList}
		 */
		getPeriodList () {
			this.form.validateFields((err,values) => {
				if(!err){
					if (!values.dateRange || !values.dateRange.length) {
						this.data = [];
						this.$message.warning("请选择日期")
						return 
					}
					var reqData = {
						"endDate": values.dateRange ? moment(values.dateRange[1]._d).format("YYYY-MM-DD") : undefined,
						"endTime": values.time1 ? (moment(values.time1._d).format("HH:mm:00")) : undefined,
						"reserveStockId": this.currnetId,
						"startDate": values.dateRange ? moment(values.dateRange[0]._d).format("YYYY-MM-DD") : undefined,
						"startTime": values.time0 ? (moment(values.time0._d).format("HH:mm:00")) : undefined,
						"weeks": this.weedSelected.length ? this.weedSelected : []
					};
					this.tableShowLoading=true;
					this.$api.totalPlatform.getReservePeriodListInfo({
						body: reqData
					}).then((data) => {
						this.tableShowLoading = false;
						this.data = data;
					}).catch(err => {
						this.tableShowLoading = false;
					})
				}
			})
		},
		/**
		 *@resetForm 表单重置
		 */
		resetForm () {
			this.form.resetFields();
			this.weedSelected=[];
			this.checkAll=false;
			this.indeterminate=false;
		},
		lookData (index) {
			this.usefulPeriodData=this.data[index].dateList;
			this.visiblePeriod=true;
		},
		//删除场次
		delPeriod (record) {
			if(this.loading){
				return
			}
			this.loading=true;
			this.$api.totalPlatform.delPeriod({
				body : record.reserveStockPeriodIds
			}).then(res => {
				this.loading=false;
				this.getPeriodList();
				this.$message.success("删除成功！");
			}).catch(res => {
				this.loading=false;
			})
		}
	},
	beforeCreate(){
		this.form=this.$form.createForm(this);
		this.periodForm=this.$form.createForm(this);
	},
	created() {},
    mounted() {
	}
};
</script>
<style lang="scss">
.amendScreening {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.district {
    width: 98%;
    height: 100%;
    margin-left: 2%;
    border: 1px solid rgba(233, 233, 233, 1);
    padding: 24px 0;
    border-radius: 2px;
    .bom {
        width: 100%;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid rgba(233, 233, 233, 1);
    }
    .a-alert {
        width: 95%;
        margin: 10px auto;
        text-align: left;
    }
    .tableBox {
        width: 95%;
        margin: 10px auto;
    }
}
#components-layout-demo-basic {
    text-align: center;
    background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
    background: #7dbcea;
    color: #fff;
}
#components-layout-demo-basic .ant-layout-footer {
    line-height: 1.5;
}
#components-layout-demo-basic .ant-layout-sider {
    background: #fff;
    color: #000000;
    font-size: 16px;
    .title {
        line-height: 60px;
        border: 1px solid rgba(233, 233, 233, 1);
        a {
            color: $text-color-primary;
        }
    }
}
</style>